import { LazyLoading } from "@/components/shared/wrappers/lazy-loading";
import { ChooseModeComponent } from "@/pages/choose-mode.component";
import { TimeService } from "@dexteel/mesf-core";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// const WorkersConfigPage =  lazy(()=>import("@/pages/configurations/workers");

const LadleOverviewComponent = lazy(() =>
	import("@/pages/ladle-track/ladle-overview").then((mod) => ({
		default: mod.LadleOverviewComponent,
	})),
);
const Ladle24HLog = lazy(() =>
	import("@/pages/ladle-track/ladle-24h-log").then((mod) => ({
		default: mod.Ladle24HLog,
	})),
);
const BrokerPage = lazy(() =>
	import("@/pages/ladle-track/broker").then((mod) => ({
		default: mod.BrokerPage,
	})),
);
const TundishTrackPlantOverviewPage = lazy(() =>
	import("@/pages/tundish-track/plant-overview").then((mod) => ({
		default: mod.TundishTrackPlantOverview,
	})),
);
const TundishTrackReports = lazy(() =>
	import("@/pages/tundish-track/reports").then((mod) => ({
		default: mod.TundishTrackReports,
	})),
);
const TundishOverviewPage = lazy(() =>
	import("@/pages/tundish-track/tundish-overview").then((mod) => ({
		default: mod.TundishOverviewPage,
	})),
);
const LadleDetailsPage = lazy(() =>
	import("@/pages/ladle-track/ladle-details").then((mod) => ({
		default: mod.LadleDetailsPage,
	})),
);
const CampaignListPage = lazy(() =>
	import("@/pages/ladle-track/campaign-list").then((mod) => ({
		default: mod.CampaignListPage,
	})),
);

const LadleCampaignsPage = lazy(() =>
	import("@/pages/ladle-track/ladle-campaigns").then((mod) => ({
		default: mod.LadleCampaignsPage,
	})),
);
const BuildLogPage = lazy(() =>
	import("@/pages/tundish-track/build-log").then((mod) => ({
		default: mod.BuildLogPage,
	})),
);
const TundishDetailsPage = lazy(() =>
	import("@/pages/tundish-track/tundish-details").then((mod) => ({
		default: mod.TundishDetailsPage,
	})),
);
const PlantOverviewComponent = lazy(() =>
	import("@/pages/ladle-track/plant-overview").then((mod) => ({
		default: mod.PlantOverviewComponent,
	})),
);

moment.tz.setDefault(TimeService.getInstance().getServerTimeZone());

const CustomRoutes = () => (
	<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
		<Routes>
			<Route path="/home" element={<Navigate to="/" replace={true} />} />
			<Route path="/" element={<Navigate to="/choose-mode" replace={true} />} />

			<Route path="/choose-mode" element={<ChooseModeComponent />} />

			{/* LADLE TRACK*/}
			<Route
				path="/ladle-track/plant-overview"
				element={<LazyLoading component={<PlantOverviewComponent />} />}
			/>
			<Route
				path="/ladle-track/ladle-overview"
				element={<LazyLoading component={<LadleOverviewComponent />} />}
			/>
			<Route
				path="/ladle-track/ladle-24-h-log"
				element={<LazyLoading component={<Ladle24HLog />} />}
			/>
			<Route
				path="/ladle-track/ladle-details/*"
				element={<LazyLoading component={<LadleDetailsPage />} />}
			/>
			<Route
				path="/ladle-track/campaigns"
				element={<LazyLoading component={<CampaignListPage />} />}
			/>
			<Route
				path="/ladle-track/ladle-campaigns"
				element={<LazyLoading component={<LadleCampaignsPage />} />}
			/>

			{/* TUNDISH TRACK*/}
			<Route
				path="/tundish-track/plant-overview"
				element={<LazyLoading component={<TundishTrackPlantOverviewPage />} />}
			/>
			<Route
				path="/tundish-track/tundish-overview"
				element={<LazyLoading component={<TundishOverviewPage />} />}
			/>
			<Route
				path="/tundish-track/build-log"
				element={<LazyLoading component={<BuildLogPage />} />}
			/>
			<Route
				path="/tundish-track/details/*"
				element={<LazyLoading component={<TundishDetailsPage />} />}
			/>
			<Route
				path="/tundish-track/reports"
				element={<LazyLoading component={<TundishTrackReports />} />}
			/>

			<Route
				path="/broker"
				element={<LazyLoading component={<BrokerPage />} />}
			/>
		</Routes>
	</LocalizationProvider>
);

export { CustomRoutes };
